import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../../src/MyPage";
import SubTabsGeneralParams from "../../../src/SubTabsGeneralParams";
import { isSuperAdmin } from "./../../helpers/user.js";
import axiosService from '../../helpers/axios';


  export default class GeneralParamsFiscalYears extends Component{ 

    constructor(props){
      super(props);

      this.state={
          years:[],
          modalTitle:"",
          fyname:"",
          yearid:0,
          isactive: true,

          YearIdFilter:"",
          YearNameFilter:"",
          IsactiveFilter:"",
          yearsWithoutFilter:[],
          fiscalyearNames: [],
          fiscalyearExists: false, 
          uniqueYearIdsForecasts:[],
          uniqueYearIdsCostGrid:[],
          uniqueYearIdsReturns:[],
          uniqueYearIdsInventories:[],
          uniqueYearIdsPurchases:[],
          isEditClicked: false,
      }
  }

  FilterFn(){
    var YearIdFilter=this.state.YearIdFilter;
    var YearNameFilter = this.state.YearNameFilter;
    var IsactiveFilter = this.state.IsactiveFilter;

    var filteredData=this.state.yearsWithoutFilter.filter(
        function(el){
            return el.yearid.toString().toLowerCase().includes(
                YearIdFilter.toString().trim().toLowerCase()
            )&&
            el.fyname.toString().toLowerCase().includes(
                YearNameFilter.toString().trim().toLowerCase()
            )&&
            el.isactive.toString().toLowerCase().includes(
                IsactiveFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({years:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.yearsWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({years:sortedData});

}

changeYearIdFilter = (e)=>{
  this.state.YearIdFilter=e.target.value;
  this.FilterFn();
}
changeYearNameFilter = (e)=>{
  this.state.YearNameFilter=e.target.value;
  this.FilterFn();
}


changeIsActiveFilter = (e)=>{
  this.state.IsactiveFilter=e.target.value;
  this.FilterFn();
}


refreshList(){
  axiosService.get('/years/')
  .then(response=>{
      const data = response.data?.results ?? response.data;
      this.setState({years:data,yearsWithoutFilter:data});
  });
}

fetchFiscalYearNames() {
  axiosService.get('/years/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const fiscalyearNames = data.map(item => item.fyname);
      this.setState({ fiscalyearNames: fiscalyearNames });
    })
    .catch(error => {
      console.error("Error fetching fiscal year names:", error);
    });
}

checkFiscalYearExists = (event) => {
  const enteredFiscalYear = event.target.value;
  const { fiscalyearNames } = this.state;
  const fiscalyearExists = fiscalyearNames.includes(parseInt(enteredFiscalYear));
  this.setState({ fiscalyearExists });
};


fetchYearIdsForecasts() {
  axiosService.get('/forecastscreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueYearIdsForecasts = [...new Set(data.map((item) => item.yearid))];
      this.setState({ uniqueYearIdsForecasts: uniqueYearIdsForecasts });
    })
    .catch((error) => {
      console.error('Error fetching Forecasts data:', error);
    });
}

fetchYearIdsCostGrid() {
  axiosService.get('/costgridcreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueYearIdsCostGrid = [...new Set(data.map((item) => item.yearid))];
      this.setState({ uniqueYearIdsCostGrid: uniqueYearIdsCostGrid });
    })
    .catch((error) => {
      console.error('Error fetching CostGrid data:', error);
    });
}

fetchYearIdsReturns() {
  axiosService.get('/returnscreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueYearIdsReturns = [...new Set(data.map((item) => item.yearid))];
      this.setState({ uniqueYearIdsReturns: uniqueYearIdsReturns });
    })
    .catch((error) => {
      console.error('Error fetching Returns data:', error);
    });
}

fetchYearIdsInventories() {
  axiosService.get('/inventoriescreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueYearIdsInventories = [...new Set(data.map((item) => item.yearid))];
      this.setState({ uniqueYearIdsInventories: uniqueYearIdsInventories });
    })
    .catch((error) => {
      console.error('Error fetching Inventories data:', error);
    });
}

fetchYearIdsPurchases() {
  axiosService.get('/purchasescreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueYearIdsPurchases = [...new Set(data.map((item) => item.yearid))];
      this.setState({ uniqueYearIdsPurchases: uniqueYearIdsPurchases });
    })
    .catch((error) => {
      console.error('Error fetching Purchases data:', error);
    });
}


componentDidMount(){
  this.refreshList();
  this.fetchFiscalYearNames();
  this.fetchYearIdsForecasts();
  this.fetchYearIdsCostGrid();
  this.fetchYearIdsReturns();
  this.fetchYearIdsInventories();
  this.fetchYearIdsPurchases();
}
changeFiscalYearName =(e)=>{
  this.setState({fyname:e.target.value});
}

changeIsActive = (event) => {
  const isChecked = event.target.checked;
  this.setState({ isactive: isChecked });
};

addClick(){
  this.setState({
      modalTitle:"Add Year",
      yearid:0,
      fyname: "",
      isactive: true,
      fiscalyearExists: false,
      isEditClicked: false,
  });
}
editClick(dep){
  this.setState({
      modalTitle:"Edit Year",
      yearid:dep.yearid,
      fyname:dep.fyname,
      isactive:dep.isactive,
      initialFyname:dep.fyname,
      initialIsactive:dep.isactive,
      fiscalyearExists: false,
      isEditClicked: false,
      isEditClicked: true,
  });
}

createClick() {
  const { fyname,  isactive, fiscalyearNames } = this.state;
  if (!fyname) {
    alert('Year is required');
    return;
  }

  if (fiscalyearNames.includes(parseInt(fyname))) {
    alert('Fiscal Year already exists. Please provide a unique Fiscal Year Name.');
    return;
  }
  
  
  axiosService.post('/years/', {
    fyname: fyname,
    isactive: isactive
  })
    .then(result => {
      alert('Year created');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}


updateClick(id){

  const { fyname,  isactive, initialFyname, initialIsactive, fiscalyearNames } = this.state;

  
   // Check if any changes are detected
   if (
    fyname === initialFyname &&
    isactive === initialIsactive
  ) {
    alert('No changes detected');
    return;
  }


  if (fiscalyearNames.includes(parseInt(fyname)) && fyname !== initialFyname) {
    this.setState({ fyname: initialFyname });
    return;
  }

  if (!fyname) {
    alert('Year is required');
    return;
  }

  

  axiosService.patch('/years/'+id+'/',{
      yearid:this.state.yearid,
      fyname:this.state.fyname,
      isactive:this.state.isactive
  })
  .then((result)=>{
      alert('Update succesful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
  })
  .catch((error)=>{
      alert('Failed');
  })
}

deleteClick(id) {
  if (this.state.uniqueYearIdsForecasts.includes(id)) {
    alert('Cannot delete this Year as it is in the Forecasts Table !');
    return; // Exit the function without making the delete request
  }

  if (this.state.uniqueYearIdsCostGrid.includes(id)) {
    alert('Cannot delete this Year as it is in the CostGrid Table !');
    return; // Exit the function without making the delete request
  }

  if (this.state.uniqueYearIdsReturns.includes(id)) {
    alert('Cannot delete this Year as it is in the Returns Table !');
    return; // Exit the function without making the delete request
  }

  if (this.state.uniqueYearIdsInventories.includes(id)) {
    alert('Cannot delete this Year as it is in the Inventories Table !');
    return; // Exit the function without making the delete request
  }
  if (this.state.uniqueYearIdsPurchases.includes(id)) {
    alert('Cannot delete this Year as it is in the Purchases Table !');
    return; // Exit the function without making the delete request
  }


  if (window.confirm('Are you sure?')) {
    axiosService.delete('/years/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        //window.location.reload(); // Refresh the page
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      years,
      modalTitle,
      yearid,
      fyname,
      isactive,
      fiscalyearExists
  }=this.state;

  return(
<div className="scrollable-container">
<MyPage />
<SubTabsGeneralParams />
<button type="button"
disabled={!isSuperAdmin()}
className="btn btn-primary m-2 float-end"
data-bs-toggle="modal"
data-bs-target="#exampleModal"
onClick={()=>this.addClick()}
style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
>
  Add Year
</button>
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
       style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeYearIdFilter}
      placeholder="Filter"/>
      </div>
      YearId
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "100px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeYearNameFilter}
      placeholder="Filter"/>

      </div>
      Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeIsActiveFilter}
      placeholder="Filter"/>

      </div>
      Is Active
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
<tbody>
  {years.map(dep=>
      <tr key={dep.yearid} className="row-hover">
          <td className="table-text">{dep.yearid}</td>
          <td className="table-text">{dep.fyname}</td>
          <td className="table-text">{dep.isactive.toString()}</td>
          <td className="table-text">

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          onClick={()=>this.deleteClick(dep.yearid)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
              <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
              </svg>
          </button>

          </td>
      </tr>
      )}
</tbody>
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Fiscal Year</span>
          <input
            type="text"
            className={`form-control ${fiscalyearExists ? "is-invalid" : ""}`}
            value={fyname}
            onChange={this.changeFiscalYearName}
            onBlur={this.checkFiscalYearExists}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          />
          {fiscalyearExists && <div className="invalid-feedback" style={{ fontSize: "12px" }} >Fiscal Year already exists.</div>}
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Isactive</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={isactive}
            onChange={this.changeIsActive}
          />
        </div>

        {yearid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {yearid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.updateClick(yearid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>


</div>
  )
}


  }

